import React from "react";
import LabelField from "component/labelField/LabelField";
import t from "module/translations";

interface Props {
  module: string;
}

const CertificationModuleLabelField: React.FC<Props> = ({ module }) => {
  return (
    <LabelField
      {...{
        caption: t.competencyManagement.certification.moduleText,
        label: module,
      }}
    />
  );
};

export default React.memo(CertificationModuleLabelField);
